import { render, staticRenderFns } from "./GarminConnector.vue?vue&type=template&id=377d9b8f&scoped=true"
import script from "./GarminConnector.vue?vue&type=script&lang=js"
export * from "./GarminConnector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377d9b8f",
  null
  
)

export default component.exports